module.exports = __webpack_public_path__ + "img/logo-sirplay-pitch-dark.svg";